import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AuthActions, useAuth, useCurrentUser } from '../AuthModule';
import { Spin, Alert } from 'antd';
import { getNetworkErrorMessage } from 'client/core/network/errors/getNetworkErrorMessage';
import { LoaderSpin } from 'client/ui/loader/LoaderSpin';
import { LoadingPage } from 'client/ui/loader/LoadingPage';
import { AlertPage } from 'client/ui/alert/AlertPage';
import { UserApi } from 'client/components/schema/user/UserApi';
import { useLocation } from 'react-router';
import { NetworkAlertPage } from 'client/components/errors/network-alert/NetworkAlertPage';
import { useGetUsersProfile } from 'client/api/backend/users/users';
import { logger } from 'client/core/logger/logger';

export interface IAuthCurrentLoaderProps {
  children: React.ReactNode;
}

const SkipHttpStatuses = [400, 401];

/**
 * Caricamento dell'utente corrente. Serve anche per controllare come side
 * effect se l'utente è loggato, in quanto i token sono salvati su
 * cookie HTTP-Only e non sono quindi accessibili da JS.
 */
export function AuthCurrentLoader(props: IAuthCurrentLoaderProps) {
  const dispatch = useDispatch();
  const { logged } = useAuth();
  const current = useCurrentUser();
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null as any);
  const [errorType, setErrorType] = useState('error' as 'error' | 'info');

  const profile = useGetUsersProfile({
    query: {
      enabled: false
    }
  });

  useEffect(() => {
    let isMounted = true;

    const fetchCurrent = async () => {
      try {
        // if (!logged) return;
        setLoading(true);
        const result = await profile.refetch({ throwOnError: true });
        logger.log(`[AuthCurretLoader] Utente loggato con successo: ${result.data?.username}`); // prettier-ignore
        dispatch(AuthActions.currentLoaded(result.data!));
      } catch (e: any) {
        // Gestiamo il caso in cui il componente è stato ricaricato
        if (!isMounted) return;
        if (e && e.response && SkipHttpStatuses.includes(e.response.status)) {
          // Semplicemente non autorizzato, lasciamo la gestione al
          // `refreshTokenInterceptor`.
        } else {
          setErrorType('error');
          setError(
            getNetworkErrorMessage(
              e,
              "Si è verificato un errore durante il caricamento dell'utente."
            )
          );
        }
      }
      setLoading(false);
    };

    fetchCurrent();

    return () => {
      isMounted = false;
    };
  }, [logged]);

  if (loading) return <LoadingPage />;

  if (error) {
    return (
      <NetworkAlertPage message="Impossibile caricare l'utente" error={error} />
    );
  }
  return <>{props.children}</>;
}
